import makeUseCellCopyAction, {
  UseCellCopyActionProps,
} from "ds/components/Table/helpers/makeUseCellCopyAction";

import useStackTasksAnalytics from "../useStackTasksAnalytics";

const useCellCopyAction = (props: UseCellCopyActionProps) => {
  return makeUseCellCopyAction({ trackAnalytics: useStackTasksAnalytics() })(props);
};

export default useCellCopyAction;
